import { render, staticRenderFns } from "./TreeAdmin.vue?vue&type=template&id=324f0f24&"
import script from "./TreeAdmin.vue?vue&type=script&lang=js&"
export * from "./TreeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TreeAdmin.vue?vue&type=style&index=0&id=324f0f24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports